const ɵ0 = {
    n: 'id',
    t: 'number|string'
};
/** Contact Definition */
export const ContactD = {
    recordTypeName: 'Contact',
    lastModifiedDate: {
        n: 'lastModifiedDate',
        t: 'number'
    },
    id: ɵ0,
    name: {
        n: 'name',
        t: 'string'
    },
    label: {
        n: 'label',
        t: 'string'
    },
    description: {
        n: 'description',
        t: 'string'
    },
    isActive: {
        n: 'isActive',
        t: 'boolean',
        d: true
    },
    created: {
        n: 'created',
        t: 'number'
    },
    createdBy: {
        n: 'createdBy',
        t: 'TenantUserI'
    },
    createdById: {
        n: 'createdById',
        t: 'number|string'
    },
    updated: {
        n: 'updated',
        t: 'number'
    },
    updatedBy: {
        n: 'updatedBy',
        t: 'TenantUserI'
    },
    updatedById: {
        n: 'updatedById',
        t: 'number|string'
    },
    externalId: {
        n: 'externalId',
        t: 'string'
    },
    tenant: {
        n: 'tenant',
        t: 'TenantI'
    },
    tenantId: {
        n: 'tenantId',
        t: 'number|string'
    },
    owner: {
        n: 'owner',
        t: 'TenantUserI'
    },
    ownerId: {
        n: 'ownerId',
        t: 'number|string'
    },
    version: {
        n: 'version',
        t: 'number'
    },
    sfId: {
        n: 'sfId',
        t: 'string'
    },
    account: {
        n: 'account',
        t: 'AccountI'
    },
    accountId: {
        n: 'accountId',
        t: 'number|string'
    },
    accountSfId: {
        n: 'accountSfId',
        t: 'string'
    },
    email: {
        n: 'email',
        t: 'string'
    },
    fax: {
        n: 'fax',
        t: 'string'
    },
    firstName: {
        n: 'firstName',
        t: 'string'
    },
    homePhone: {
        n: 'homePhone',
        t: 'string'
    },
    phone: {
        n: 'phone',
        t: 'string'
    },
    lastName: {
        n: 'lastName',
        t: 'string'
    },
    mobilePhone: {
        n: 'mobilePhone',
        t: 'string'
    },
    otherPhone: {
        n: 'otherPhone',
        t: 'string'
    },
    mailingAddress: {
        n: 'mailingAddress',
        t: 'string'
    },
    mailingCity: {
        n: 'mailingCity',
        t: 'string'
    },
    mailingStreet: {
        n: 'mailingStreet',
        t: 'string'
    },
    mailingPostalCode: {
        n: 'mailingPostalCode',
        t: 'string'
    },
    mailingState: {
        n: 'mailingState',
        t: 'string'
    },
    title: {
        n: 'title',
        t: 'string'
    },
    mailingCountry: {
        n: 'mailingCountry',
        t: 'string'
    },
    reportsTo: {
        n: 'reportsTo',
        t: 'ContactI'
    },
    reportsToId: {
        n: 'reportsToId',
        t: 'number|string'
    },
    reportsToSfId: {
        n: 'reportsToSfId',
        t: 'string'
    },
    department: {
        n: 'department',
        t: 'string'
    },
    birthdate: {
        n: 'birthdate',
        t: 'number'
    },
    assistantName: {
        n: 'assistantName',
        t: 'string'
    },
    assistantPhone: {
        n: 'assistantPhone',
        t: 'string'
    },
    salutation: {
        n: 'salutation',
        t: 'string'
    },
}; // Contact
export { ɵ0 };
